export default __webpack_public_path__ + "static/media/Issue-will-be-resolved-based-on-your-priority.6841d6d0.png";